// extracted by mini-css-extract-plugin
export default {"CreateAnAccount":"SignUp_CreateAnAccount__-Tm3t","CreateAnAccountBox":"SignUp_CreateAnAccountBox__khrAD","socialContent":"SignUp_socialContent__k6ajB"};